import { render, staticRenderFns } from "./newproeval.vue?vue&type=template&id=6faef91a&scoped=true&"
import script from "./newproeval.vue?vue&type=script&lang=js&"
export * from "./newproeval.vue?vue&type=script&lang=js&"
import style0 from "./newproeval.vue?vue&type=style&index=0&id=6faef91a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faef91a",
  null
  
)

export default component.exports